var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1627_4751)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1627_4751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9994 13.2135C13.0146 13.2135 13.8405 12.3875 13.8405 11.3723V3.84109C13.8405 2.82594 13.0146 2 11.9994 2C10.9842 2 10.1582 2.82594 10.1582 3.84113V11.3724C10.1582 12.3876 10.9842 13.2135 11.9994 13.2135Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1971 7.0859C18.1924 7.08078 18.1876 7.07582 18.1832 7.07141C17.8354 6.72371 17.3731 6.53223 16.8814 6.53223C16.3896 6.53223 15.9272 6.72367 15.5795 7.07141C15.2317 7.41914 15.0402 7.88152 15.0402 8.37336C15.0402 8.85723 15.2257 9.31258 15.5629 9.65836C15.5683 9.6641 15.5737 9.6698 15.5794 9.67543C16.5355 10.6316 17.0621 11.9029 17.0621 13.2552C17.0621 16.0467 14.7911 18.3177 11.9996 18.3177C9.20816 18.3177 6.93711 16.0467 6.93711 13.2552C6.93711 11.9029 7.46367 10.6316 8.41988 9.67543C9.13758 8.9577 9.13766 7.78969 8.41973 7.07152C8.07195 6.72391 7.60957 6.53242 7.11789 6.53242C6.62613 6.53242 6.16383 6.72391 5.81609 7.07168C4.16445 8.72336 3.25488 10.9194 3.25488 13.2552C3.25488 15.591 4.16445 17.787 5.81613 19.4387C7.46781 21.0904 9.66379 22 11.9996 22C14.3354 22 16.5314 21.0904 18.1831 19.4387C19.8348 17.787 20.7443 15.591 20.7443 13.2552C20.7443 10.9263 19.8399 8.7359 18.1971 7.0859Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1627_4751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1627_4751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "static/media/off.74bf241810e66b109d115582da557ec4.svg";
export { ForwardRef as ReactComponent };